import EnviromentConfig from "../configs/enviromentConfig";
const API_URL = EnviromentConfig.API_URL;

export const api = {
      auth: {
            // Paso 1: enviar email
            async signupEmail(email, 
              captchaToken 
            ) {
              const res = await fetch(`${API_URL}/api/auth/send-code`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, deviceId: "web-client", 
                  captcha: captchaToken 
                  }),
              });
              if (!res.ok) throw await res.json();
              return await res.json();
            },
              
            async forgotPasswordEmail(email, 
              captchaToken 
            ) {
              const res = await fetch(`${API_URL}/api/auth/send-code-forgotpassword`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, deviceId: "web-client", 
                  captcha: captchaToken 
                  }),
              });
              if (!res.ok) throw await res.json();
              return await res.json();
            },

            // Paso 2: verificar código
            async checkEmailVerified(email, otp) {
              const res = await fetch(`${API_URL}/api/auth/verify-code`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, otp, deviceId: "web-client", trusted: true }),
              });
              if (!res.ok) throw await res.json();
              return await res.json(); 
            },
            async checkEmailVerifiedRegister(email, otp) {
              const res = await fetch(`${API_URL}/api/auth/verify-code-register`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, otp, deviceId: "web-client", trusted: true }),
              });
              if (!res.ok) throw await res.json();
              return await res.json(); 
            },

            async loginUser(email, contraseña, captchaToken) {
              const res = await fetch(`${API_URL}/api/auth/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({email, contraseña, deviceId: "web-client",  captcha: captchaToken}),
              });
                console.log("RES STATUS:", res.status); 
              if (!res.ok) throw await res.json();
              return await res.json(); 
            },
          },
      usuario: {
            // Paso 3: registrar usuario
            async registerUser(email, form) {
              const token = localStorage.getItem("token")?.trim();
              console.log("TOKEN:",token)
              const res = await fetch(`${API_URL}/api/register`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: token, 
                },
                body: JSON.stringify({ email, ...form }),
              });
              if (!res.ok) throw await res.json();
              return await res.json();
            },

            async updateUserPassword(contraseña) {
              const token = localStorage.getItem("token")?.trim();
              const res = await fetch(`${API_URL}/api/usuario/update-password`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: token, 
                },
                body: JSON.stringify({ contraseña }),
              });
              if (!res.ok) throw await res.json();
              return await res.json();
            },

          async getUsuarioByInternalId(internalId) {
            const res = await fetch(`${API_URL}/api/usuario/byInternalId/${internalId}`, {
                method: "GET",
                headers: { 
                "Content-Type": "application/json",
                },
            });
            if (!res.ok) throw await res.json();
            return await res.json();
        }
     }
  }
